import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'
import { motion } from 'framer-motion'
import { useDispatch, useSelector } from 'react-redux'
import { saveAs } from 'file-saver'
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

// COMPONENT
import * as styled from '../../../style/main.style'
import Header from '../../../Header'
import Navbar from '../../../Navbar'
import TableCustom from '../../../../../component/table/tableCustom'
import { StrategyApi } from '../../../../../api/strategy/strategy.api'

import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice'
import Loading from '../../../../../component/loading/Loading'
import SearchAutocompleteSelect from '../../../../../component/select/searchAutocompleteSelect'
import TableRowCommon from '../../../../../component/table/TableRowCommon'
import { FiscalYearApi } from '../../../../../api/fiscal-year/fiscalyear.api'
import { ReportApi } from '../../../../../api/report/report.api';

import MenuDropdown from '../../../../../component/menu-dropdown/MenuDropdown'
import { numberFormat } from '../../../../../utils/common'
import { DepartMentApi } from '../../../../../api/department/department.api'


interface Column {
    id: 'name' | 'code' | 'population' | 'size' | 'density';
    label: string;
    minWidth?: number;
    align?: 'right' | 'center';
    format?: (value: number) => string;
}
const budget: Column[] = [
    { id: 'name', label: 'ยุทธศาสตร์ชาติ', align: "center", minWidth: 150 },
    { id: 'name', label: 'แผนแม่บท', align: "center", minWidth: 150 },
    { id: 'name', label: 'แผนย่อย', align: "center", minWidth: 150 },
];
const performance: Column[] = [
    { id: 'name', align: "right", label: 'เชิงผลผลิต', minWidth: 170 },
    { id: 'name', align: "right", label: 'เชิงผลลัพธ์', minWidth: 200 },
    { id: 'name', align: "right", label: 'กลุ่มเป้าหมาย', minWidth: 170 },
    { id: 'name', align: "center", label: 'ตัวชี้วัด', minWidth: 160 },
];
const plane: Column[] = [
    { id: 'name', label: 'เป็นตามแผน', minWidth: 130 },
    { id: 'name', label: 'ไม่เป็นตามแผน', minWidth: 130 },
];

const EvaluationReport = () => {
    const { t } = useTranslation();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    const dispatch = useDispatch();

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalPage, setTotalPage] = useState<number>(2);

    const [strategy, setStrategy] = useState<any[]>([]);
    const [dataReport, setDataReport] = useState<any[]>([]);

    const [idFiscalYear, setIdFiscalYear] = useState<number>(0);
    const [idDepartment, setIdDepartment] = useState<number>(Number);


    const headCells = [
        {
            id: "FIR",
            disablePadding: true,
            align: "center",
            width: 100,
            label: "ที่"
        },
        {
            id: "idFiscalYear",
            disablePadding: true,
            align: "center",
            width: 200,
            label: "ปีงบประมาณ"
        },
        {
            id: "strategyName",
            disablePadding: true,
            align: "center",
            width: 350,
            label: "ยุทธศาสตร์"
        },
        {
            id: "Stragy",
            disablePadding: true,
            align: "center",
            width: 300,
            label: "หน่วยงาน"
        },
        {
            id: "PLAN",
            disablePadding: true,
            align: "center",
            width: 300,
            label: "แผนงาน"
        },
        {
            id: "projectName",
            disablePadding: true,
            width: 300,
            align: "center",
            label: "โครงการ"
        },
        {
            id: "BUDGET", width: 500, align: "center", label:
                <TableHead>
                    <TableRow style={{ borderBottom: "2px solid #fff" }}>
                        <TableCell align="center" colSpan={6}>
                            <Typography>{"ความก้าวหน้าของโครงการต่อแผนทั้งสามระดับ"}</Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        {budget.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ top: 57, minWidth: column.minWidth, width: "100%" }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
        },
        {
            id: "PERFORMANCE", width: 740, disablePadding: true, align: "center", label:
                <TableHead>
                    <TableRow style={{ borderBottom: "2px solid #fff" }}>
                        <TableCell align="center" colSpan={8}>
                            <Typography>{"การประเมินเป้าหมายและตัวชี้วัด"}</Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow style={{ textAlign: 'center' }}>
                        {performance.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ top: 57, minWidth: column.minWidth }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { id, projectName, planName, fiscalYear, departmentName, strategyName,resultOfTargetProductivity,resultOfTargetResult, inLineWithNationalStrategy, inLineWithTargetMain, inLineWithTargetSub, resultOfTargetGroup,resultIndicators } =
            objData;

        const objRenderData = {
            key: no,
            id: id,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: fiscalYear || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: strategyName || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: departmentName || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: planName || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: projectName || "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    width: 400,
                    component:
                        <TableBody sx={{ display: "grid", }} className='grid grid-cols-9 w-full h-full'>
                            <TableCell style={{ textAlign: 'center', border: "none" }} className='text-right col-span-3'>
                                {inLineWithNationalStrategy || "-"}
                            </TableCell>
                            <TableCell style={{ textAlign: 'center', border: "none" }} className='text-right col-span-3'>
                                {inLineWithTargetMain || "-"}
                            </TableCell>
                            <TableCell style={{ textAlign: 'center', border: "none" }} className='text-right col-span-3'>
                                {inLineWithTargetSub || "-"}
                            </TableCell>
                        </TableBody>
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    // colSpan: 8,
                    width: 500,
                    style: { width: "100%" },
                    component:
                        <TableBody>
                            <TableCell style={{ width: "190px", textAlign: "center", border: "none" }} colSpan={2}>
                                {resultOfTargetProductivity || "-"}
                            </TableCell>
                            <TableCell style={{ width: "180px", textAlign: "center", border: "none" }} colSpan={2}>
                                {resultOfTargetResult || "-"}
                            </TableCell>
                            <TableCell style={{ width: "190px", textAlign: "center", border: "none" }} colSpan={2}>
                                {resultOfTargetGroup || "-"}
                            </TableCell>
                            <TableCell style={{ width: "160px", textAlign: "center", border: "none" }} colSpan={2}>
                                {resultIndicators || "-"}
                            </TableCell>
                        </TableBody>
                }
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };
    const handleGetStrategy = async () => {
        let condition: any = {}
        await StrategyApi.getStrategy(condition)
            .then(res => {
                if (res.status === 200) {
                    setStrategy(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    const handleGetReport = useCallback(async () => {
        dispatch(setLoading())
        let condition: any = {
            idFiscalYear: idFiscalYear
        }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        if (idDepartment) condition = { ...condition, idDepartment: idDepartment }
        await ReportApi.getEvaluationReport(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    // console.log(res.data?.result)
                    setDataReport(res.data?.result)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }, [idFiscalYear, idDepartment])

    const handleGetFile = async (format: 'pdf' | 'excel') => {
        try {
            dispatch(setLoading())
            let condition: any = {
                format: format
            }
            if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
            if (idDepartment) condition = { ...condition, idDepartment: idDepartment }
            await ReportApi.getEvaluationReportFile(condition)
                .then(res => {
                    if (res.status === 200) {
                        dispatch(unsetLoading())
                        const data = res?.data
                        if (format === 'pdf') {
                            const blob = new Blob([data], { type: 'application/pdf' });
                            saveAs(blob, 'ผลความสำเร็จโครงการ-pdf');
                        } else if (format === 'excel') {
                            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            saveAs(blob, 'ผลความสำเร็จโครงการ-excel');
                        }
                    }
                })
                .catch(error => {
                    dispatch(unsetLoading())
                    console.log(error)
                })
        } catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        handleGetReport();
    }, [handleGetReport])

    useEffect(() => {
        handleGetStrategy()
    }, [])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <motion.div
                        initial={{ x: 100 }}
                        animate={{ x: 0 }}
                        transition={{ ease: "backInOut", stiffness: 100 }}
                        className='w-full h-auto'>
                        <section>
                            <Typography className='text-primary' variant='h4'>
                                {"รายงาน"}
                            </Typography>
                            <Typography variant='h6' className='text-primary mt-3'>
                                {"รายงานความสำเร็จของโครงการในภาพรวม"}
                            </Typography>
                        </section>
                        <section className='w-full mt-8'>
                            <article className='flex flex-col md:flex-row justify-between items-center'>
                                <span className='grid grid-cols-12 gap-2 w-full'>
                                    <span className='col-span-6 md:col-span-4'>
                                        <SearchAutocompleteSelect
                                            headingNormal
                                            heading={t("ปีงบประมาณ")}
                                            labelId="label-fiscal-year"
                                            idKey="idFiscalYear"
                                            value={idFiscalYear}
                                            serverSearch={false}
                                            fetchOptions={(condition) => FiscalYearApi.getFiscalYear(condition)}
                                            getOptionLabel={(option) => String(option?.fiscalYear ?? '')}
                                            statusKey="fiscalYearStatus"
                                            onChange={(id) => setIdFiscalYear(id)}
                                        />
                                    </span>
                                    <span className='col-span-6 md:col-span-4'>
                                        <SearchAutocompleteSelect
                                            headingNormal
                                            heading={t("หน่วยงาน")}
                                            labelId="label-department"
                                            idKey="idDepartment"
                                            value={idDepartment}
                                            fetchOptions={(condition) => DepartMentApi.getDepartments(condition)}
                                            getOptionLabel={(option) => option?.departmentName}
                                            statusKey="departmentStatus"
                                            onChange={(id) => setIdDepartment(id)}
                                        />
                                    </span>
                                </span>
                                <span className='w-full md:w-auto'>
                                    <div className='w-auto flex flex-col self-end gap-2'>
                                        <MenuDropdown
                                            headingNormal
                                            heading='ส่งออกเอกสาร'
                                            buttonName='ดาวน์โหลด'
                                            menuItems={[
                                                { id: 1, name: "pdf", onClick: () => handleGetFile('pdf') },
                                                { id: 2, name: 'excel', onClick: () => handleGetFile('excel') }
                                            ]}
                                        />
                                    </div>
                                </span>

                            </article>
                        </section>
                        <section className='w-full mt-3'>
                            <TableCustom
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy=""
                                sortType="ASC"
                                headCells={headCells}
                                rowCount={totalPage}
                                rowsData={dataReport && dataReport?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={() => { }}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                                hidePagination
                                tableFixedWidth
                            />
                        </section>
                    </motion.div>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default EvaluationReport
